// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #0255A5;
  --primary-color-rgb:2, 85, 165;
  --primary-color-hover:#0F3B66;
  --primary-color-opacity: rgba(2, 85, 165, 0.1);
  --light-grey:#F9F9F9;
  --light-grey-rgb:249, 249, 249;
  --dark-grey:#9A9C9F;
  --dark-grey-rgb:154, 156, 159;
  --darkGrey:#1b232c;
  --hover-bg-color:#E4E8EF;
  --white-bg-hover:#e8eff2;
  --light-blue:#6A80A9;
  --purple:#675081;
  --purple-rgb:103, 80, 129;
  --textHighlightBgColor:rgba(191, 219, 253, 0.90);
  --textHighlightFontColor:var(--primary-font-color);
  --primary-font-color: var(--surface-500);
  --primary-font-color-rgb: var(--surface-500-rgb);
  --secondary-font-color: var(--surface-700);
  --disabled-font-color:#828b97;
  --font:"Open Sans", Arial, sans-serif;
  --h1:24px;
  --h2:18px;
  --h3:16px;
  --h4:13px;
  --bodyFontSize:14px;
  --tableFontSize:12px;
  --pageTitleSize:var(--h1);
  --sectionTitleSize:var(--h2);
  --sectionSubTitleSize:var(--tableFontSize);
  --sectionTitleLabel:var(--h3);
  --accordionTitleSize:var(--sectionTitleSize);
  --border-color: var(--surface-100);
  --darkBorderColor: var(--textHighlightFontColor);
  --table-border-color:#E8EFF2;
  --table-border-style:1px solid var(--table-border-color);
  --border-style:1px solid var(--border-color);
  --border-lg-radius:8px;
  --border-m-radius:4px;
  --border-m-radius-top:4px 4px 0px 0px;
  --border-m-radius-bottom:0px 0px 4px 4px;
  --border-sm-radius:2px;
  --border-radius-tab:2px 2px 0px 0px;
  --selected-text:#E4E8EF;
  --selected-bg:#E4E8EF;
  --table-alt-row-color: var(--light-grey);
  --alert-warning:#D6BA17;
  --alert-warning-rgb:214, 186, 23;
  --alert-warning-opacity: rgba(214, 186, 23, 0.10);
  --alert-success:#02a570;
  --alert-success-rgb:2, 165, 112;
  --alert-success-opacity: rgba(2, 165, 112, 0.10);
  --alert-info: var(--primary-color);
  --alert-info-rgb: var(--primary-color-rgb);
  --alert-info-opacity: rgba(2, 85, 165, 0.11);
  --alert-danger:#E02222;
  --alert-danger-rgb:224, 34, 34;
  --alert-danger-opacity: rgba(224, 34, 34, 0.10);
  --alert-danger-hover: #871a1a;
  --alert-medium:#F97031;
  --alert-medium-rgb:249, 112, 49;
  --brown:#5b4434;
  --notification-warning-bg:#FAF8E7;
  --notification-info-bg:#E5EEF6;
  --notification-error-bg:#FBE8E8;
  --notification-success-bg:#E5F6F0;
  --shadow-color:rgba(89,101,118,0.32);
  --shadow-sm: 0 2px 5px 0 var(--shadow-color);
  --shadow-md: 0 0px 10px 0 var(--shadow-color);
  --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);
  --accent: \$primary-color !important;
  --primary: \$primary-color!important;
  --series-a: \$primary-color !important;
  --primary-0:#ebf7ff;
  --primary-0-rgb:235, 247, 255;
  --primary-50:#a9d3ef;
  --primary-100:#6fb2de;
  --primary-100-rgb:111, 178, 222;
  --primary-200:#4093cd;
  --primary-300:#1c74ba;
  --primary-300-rgb:28, 116, 186;
  --primary-400:#0255A5;
  --primary-500:#0046aa;
  --primary-600:#0b399c;
  --primary-700:#102669;
  --primary-800:#08112d;
  --primary-900:#070a16;
  --white:#ffffff;
  --white-rgb:255, 255, 255;
  --surface-0: #fefefe;
  --surface-50: #d7dfe5;
  --surface-50-rgb:215, 223, 229;
  --surface-100: #bac4cb;
  --surface-100-rgb:186, 196, 203;
  --surface-200: #9ea8b1;
  --surface-200-rgb:158, 168, 177;
  --surface-300: #828b97;
  --surface-400: #666f7d;
  --surface-500: #4B5363;
  --surface-500-rgb:75, 83, 99;
  --surface-600: #373d4f;
  --surface-700: #25283a;
  --surface-700-rgb:37, 40, 58;
  --surface-800: #151726;
  --surface-800-rgb:21, 23, 38;
  --surface-900: #090912;
  --size-0: 2px;
  --size-50: 4px;
  --size-100: 6px;
  --size-200: 8px;
  --size-300: 10px;
  --size-400: 16px;
  --size-500: 32px;
  --size-600: 48px;
  --size-700: 54px;
  --size-800: 70px;
  --size-900: 86px;
  --media-tablet-pro: 992px;
  --media-tablet: var(--media-tablet-pro);
  --media-mobile: 480px;
  --media-min: 0px;
  --priority-pm:var(--primary-color);
  --priority-high:var(--alert-danger);
  --priority-hot-parts: #059ea5;
  --priority-warranty: #e035bf;
  --priority-overtime-approval:var(--alert-warning);
  --priority-normal:var(--alert-success);
  --priority-special-equipment:#675081;
  --priority-locked-scheduled:var(--secondary-font-color);
}
:root .zuggit-base {
  --primary-color: #323283;
  --primary-0: #f2f4ff;
  --primary-0-rgb:242, 244, 255;
  --primary-50: #c4c5f2;
  --primary-100: #9b9be6;
  --primary-100-rgb:155, 155, 230;
  --primary-200: #7b7cd9;
  --primary-300: #5a5acb;
  --primary-300-rgb:90, 90, 203;
  --primary-400: #323283;
  --primary-500: #2a2a95;
  --primary-600: #242484;
  --primary-700: #1d1d63;
  --primary-800: #141441;
  --primary-900: #0c0c22;
  --surface-0: #fbfaff;
  --surface-50: #dcd9e4;
  --surface-50-rgb:220, 217, 228;
  --surface-100: #c1beca;
  --surface-100-rgb:193, 190, 202;
  --surface-200: #a6a3b1;
  --surface-200-rgb:166, 163, 177;
  --surface-300: #8b8798;
  --surface-400: #716c80;
  --surface-500: #585166;
  --surface-500-rgb:88, 81, 102;
  --surface-600: #423b4f;
  --surface-700: #2e2938;
  --surface-700-rgb:46, 41, 56;
  --surface-800: #1c1824;
  --surface-800-rgb:28, 24, 36;
  --surface-900: #0d0a12;
}

.m-0 {
  margin: 0;
}
.m-1 {
  margin: var(--size-100);
}
.m-2 {
  margin: var(--size-200);
}
.m-3 {
  margin: var(--size-300);
}
.m-4 {
  margin: var(--size-400);
}
.m-5 {
  margin: var(--size-500);
}
.m-6 {
  margin: var(--size-600);
}
.m-7 {
  margin: var(--size-700);
}
.m-8 {
  margin: var(--size-800);
}
.m-9 {
  margin: var(--size-900);
}
.mt-0 {
  margin-top: 0;
}
.mt-1 {
  margin-top: var(--size-100);
}
.mt-2 {
  margin-top: var(--size-200);
}
.mt-3 {
  margin-top: var(--size-300);
}
.mt-4 {
  margin-top: var(--size-400);
}
.mt-5 {
  margin-top: var(--size-500);
}
.mt-6 {
  margin-top: var(--size-600);
}
.mt-7 {
  margin-top: var(--size-700);
}
.mt-8 {
  margin-top: var(--size-800);
}
.mt-9 {
  margin-top: var(--size-900);
}
.mr-0 {
  margin-right: 0;
}
.mr-1 {
  margin-right: var(--size-100);
}
.mr-2 {
  margin-right: var(--size-200);
}
.mr-3 {
  margin-right: var(--size-300);
}
.mr-4 {
  margin-right: var(--size-400);
}
.mr-5 {
  margin-right: var(--size-500);
}
.mr-6 {
  margin-right: var(--size-600);
}
.mr-7 {
  margin-right: var(--size-700);
}
.mr-8 {
  margin-right: var(--size-800);
}
.mr-9 {
  margin-right: var(--size-900);
}
.mb-0 {
  margin-bottom: 0;
}
.mb-1 {
  margin-bottom: var(--size-100);
}
.mb-2 {
  margin-bottom: var(--size-200);
}
.mb-3 {
  margin-bottom: var(--size-300);
}
.mb-4 {
  margin-bottom: var(--size-400);
}
.mb-5 {
  margin-bottom: var(--size-500);
}
.mb-6 {
  margin-bottom: var(--size-600);
}
.mb-7 {
  margin-bottom: var(--size-700);
}
.mb-8 {
  margin-bottom: var(--size-800);
}
.mb-9 {
  margin-bottom: var(--size-900);
}
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: var(--size-100);
}
.ml-2 {
  margin-left: var(--size-200);
}
.ml-3 {
  margin-left: var(--size-300);
}
.ml-4 {
  margin-left: var(--size-400);
}
.ml-5 {
  margin-left: var(--size-500);
}
.ml-6 {
  margin-left: var(--size-600);
}
.ml-7 {
  margin-left: var(--size-700);
}
.ml-8 {
  margin-left: var(--size-800);
}
.ml-9 {
  margin-left: var(--size-900);
}

.p-0 {
  padding: 0;
}
.p-1 {
  padding: var(--size-100);
}
.p-2 {
  padding: var(--size-200);
}
.p-3 {
  padding: var(--size-300);
}
.p-4 {
  padding: var(--size-400);
}
.p-5 {
  padding: var(--size-500);
}
.p-6 {
  padding: var(--size-600);
}
.p-7 {
  padding: var(--size-700);
}
.p-8 {
  padding: var(--size-800);
}
.p-9 {
  padding: var(--size-900);
}
.pt-0 {
  padding-top: 0;
}
.pt-1 {
  padding-top: var(--size-100);
}
.pt-2 {
  padding-top: var(--size-200);
}
.pt-3 {
  padding-top: var(--size-300);
}
.pt-4 {
  padding-top: var(--size-400);
}
.pt-5 {
  padding-top: var(--size-500);
}
.pt-6 {
  padding-top: var(--size-600);
}
.pt-7 {
  padding-top: var(--size-700);
}
.pt-8 {
  padding-top: var(--size-800);
}
.pt-9 {
  padding-top: var(--size-900);
}
.pr-0 {
  padding-right: 0;
}
.pr-1 {
  padding-right: var(--size-100);
}
.pr-2 {
  padding-right: var(--size-200);
}
.pr-3 {
  padding-right: var(--size-300);
}
.pr-4 {
  padding-right: var(--size-400);
}
.pr-5 {
  padding-right: var(--size-500);
}
.pr-6 {
  padding-right: var(--size-600);
}
.pr-7 {
  padding-right: var(--size-700);
}
.pr-8 {
  padding-right: var(--size-800);
}
.pr-9 {
  padding-right: var(--size-900);
}
.pb-0 {
  padding-bottom: 0;
}
.pb-1 {
  padding-bottom: var(--size-100);
}
.pb-2 {
  padding-bottom: var(--size-200);
}
.pb-3 {
  padding-bottom: var(--size-300);
}
.pb-4 {
  padding-bottom: var(--size-400);
}
.pb-5 {
  padding-bottom: var(--size-500);
}
.pb-6 {
  padding-bottom: var(--size-600);
}
.pb-7 {
  padding-bottom: var(--size-700);
}
.pb-8 {
  padding-bottom: var(--size-800);
}
.pb-9 {
  padding-bottom: var(--size-900);
}
.pl-0 {
  padding-left: 0;
}
.pl-1 {
  padding-left: var(--size-100);
}
.pl-2 {
  padding-left: var(--size-200);
}
.pl-3 {
  padding-left: var(--size-300);
}
.pl-4 {
  padding-left: var(--size-400);
}
.pl-5 {
  padding-left: var(--size-500);
}
.pl-6 {
  padding-left: var(--size-600);
}
.pl-7 {
  padding-left: var(--size-700);
}
.pl-8 {
  padding-left: var(--size-800);
}
.pl-9 {
  padding-left: var(--size-900);
}

/*%pageTitleFont{
    font-size:\$pageTitleSize;
    font-weight:800;
}
%sectionTitleFont{
    font-size:var(--sectionTitleSize);
    font-weight:800;
}
%sectionSubTitleFont{
    font-size:var(--sectionSubTitleSize);
    font-weight:400;
}*/
/* chart 
buttons
date input
dialogs
dropdowns
iputs
grid
label
layout
tab strip
bound bar
menues
popup
scroll view
toolbar
tool tip
editor */
.dispatch {
  width: 100%;
  border: var(--border-style);
  background-color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0px 5px;
  border-radius: var(--border-m-radius);
  cursor: pointer;
  position: relative;
  margin: 5px 0;
  align-items: center;
}
.dispatch.hasLabor h3 {
  color: var(--secondary-font-color);
}
.dispatch.dispatch-focused {
  box-shadow: var(--shadow-sm);
  transform: scale(1.08);
}
.dispatch.dispatch-focused .dispatch-menu {
  display: block;
}
.dispatch:hover {
  box-shadow: var(--shadow-sm);
  transform: scale(1.02);
  transition-duration: 0.2s;
}
.dispatch:hover .dispatch-menu {
  display: block;
}
.dispatch.selected-dispatch:after {
  content: "";
  width: 100%;
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 20;
  pointer-events: none;
  border-radius: var(--border-m-radius);
  box-shadow: inset 0px 0px 6px 0px var(--primary-color);
}
.dispatch .dispatchDetails {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.dispatch .dispatchDetails .priority-block {
  display: block;
  width: 12px;
  min-width: 8px;
  height: 12px;
  border-radius: var(--border-sm-radius);
  margin: 0px 5px 0px 0px;
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber::after {
  content: "";
  position: absolute;
  text-align: center;
  width: 12px;
  height: 12px;
  font-size: 10px;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.one::after {
  content: "1";
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.two::after {
  content: "2";
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.three::after {
  content: "3";
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-high {
  color: var(--white);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-hot-parts {
  color: var(--white);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-normal {
  color: var(--white);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-warranty {
  background-color: var(--priority-warranty);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-pm {
  color: var(--white);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-locked-scheduled {
  color: var(--white);
}
.dispatch .dispatchDetails .priority-block.partPriorityNumber.priority-special-equipment {
  color: var(--white);
}
.dispatch .dispatchDetails h3 {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: var(--primary-font-color);
  flex-grow: 2;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: calc(100% - 13px);
  padding: 0px;
  margin: 0px;
  line-height: 34px;
  overflow: hidden;
}
.dispatch.white .dispatchDetails h3 {
  color: #ffffff;
}
.dispatch.white .partPriority {
  border-top-color: rgba(var(--surface-100-rgb), 0.5);
}
.dispatch .dispatch-menu {
  position: absolute;
  right: 1px;
  top: 1px;
  display: none;
  z-index: 9999;
  background-color: #ffffff;
  pointer-events: none;
}
.dispatch .dispatch-timer-wrap {
  position: absolute;
  width: 100%;
  height: 4px;
  border-top: var(--border-style);
  overflow: hidden;
  bottom: 0px;
  margin: 0px -5px;
}
.dispatch .dispatch-timer-wrap .dispatch-timer {
  height: 3px;
}
.dispatch .dispatch-timer-wrap .dispatch-timer.two-hour {
  width: 33%;
  background-color: var(--alert-success);
}
.dispatch .dispatch-timer-wrap .dispatch-timer.four-hour {
  width: 33%;
  background-color: var(--alert-warning);
}
.dispatch .dispatch-timer-wrap .dispatch-timer.twenty-four-hour {
  width: 33%;
  background-color: var(--alert-danger);
}
.dispatch {
  /*.partPriority{
      display:flex;
      flex-direction: row;
      height: 4px;
      width: calc(100% + 10px);
      margin: 0 -5px 0 -5px;
      border-width: 1px 0 0 0;
      border-top-color: var(--border-color);
      border-style: solid;
      .step{
          flex-grow:1;
          border-width: 0 1px 0 0;
          border-color: var(--border-color);
          border-style:solid;
          background-color: rgba( var(--white-rgb), 0.6);
          &:last-child{
            border:none;
          }
          &.levelOne{background-color:var(--primary-color);}
          &.levelTwo{background-color:var(--alert-warning);}
          &.levelThree{background-color:var(--alert-danger);}
      }
  }*/
}
.dispatch .partPriority {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 34px;
  width: 5px;
  border-radius: 0 4px 4px 0;
  margin-right: -5px;
  border-width: 0 0 0 1px;
  border-color: var(--border-color);
  border-style: solid;
  background-color: rgba(var(--white-rgb), 0.6);
  justify-content: flex-end;
  z-index: 0;
}
.dispatch .partPriority .step {
  width: 100%;
}
.dispatch .partPriority.levelOne .step {
  background-color: var(--primary-color);
  height: 33%;
}
.dispatch .partPriority.levelTwo .step {
  background-color: var(--alert-warning);
  height: 66%;
}
.dispatch .partPriority.levelThree .step {
  background-color: var(--alert-danger);
  height: 100%;
}
.dispatch .partPriority:before {
  content: "";
  height: 33%;
  width: 100%;
  border-width: 1px 0;
  border-color: var(--border-color);
  border-style: solid;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1;
}
.dispatch .partPriority:after {
  content: "";
}
.dispatch:hover .partPriority .step:after {
  position: absolute;
  top: -1px;
  left: -20px;
  width: 20px;
  height: calc(100% + 2px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: 900;
  border-radius: 4px 0 0 4px;
  border-width: 1px;
  border-color: var(--border-color);
  border-style: solid;
  background-color: rgba(var(--white-rgb), 0.6);
}
.dispatch:hover .partPriority.levelOne .step:after {
  content: "1";
}
.dispatch:hover .partPriority.levelTwo .step:after {
  content: "2";
}
.dispatch:hover .partPriority.levelThree .step:after {
  content: "3";
}

.cdk-drag-dragging {
  position: fixed;
  max-width: 200px;
}

.drag-placeholder {
  height: 40px;
  margin: 5px;
  width: 100%;
  border-color: var(--disabled-font-color);
  background-color: var(--shadow-color);
  opacity: 0.4;
  border-radius: 4px;
  border-style: dashed;
  border-width: 3px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-animating {
  transition: transform 300ms cubic-bezier(0, 0, 0.2, 1);
}

#dispatch-tooltip {
  display: flex;
  flex-flow: row wrap;
  max-width: 315px;
  z-index: 99999999999;
}
#dispatch-tooltip .tooltip-logo {
  min-width: 60px;
  max-width: 60px;
  min-height: 60px;
  max-height: 60px;
  overflow: hidden;
  text-align: center;
  margin-right: 10px;
  border: var(--border-style);
  border-radius: var(--border-m-radius);
}
#dispatch-tooltip .tooltip-logo img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
#dispatch-tooltip .tooltip-header {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 10px;
}
#dispatch-tooltip .tooltip-header .tooltip-title {
  color: var(--primary-font-color);
  flex-grow: 2;
  /*display: flex;
  flex-flow: row wrap;
  margin-bottom:20px;*/
}
#dispatch-tooltip .tooltip-header .tooltip-title h1 {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 5px 0;
  width: 100%;
}
#dispatch-tooltip .tooltip-header .location {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}
#dispatch-tooltip .tooltip-header .location span {
  font-size: 12px;
  width: 100%;
  font-weight: 500;
}
#dispatch-tooltip .tooltip-content {
  color: var(--primary-font-color);
  width: 100%;
  display: flex;
  flex-flow: column wrap;
}
#dispatch-tooltip .tooltip-content .sub-header {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
}
#dispatch-tooltip .tooltip-content .sub-header h2 {
  font-size: 12px;
  font-weight: 500;
  margin: 0 0 10px 0;
  flex-grow: 2;
}
#dispatch-tooltip .tooltip-content .sub-header h2:last-child {
  text-align: right;
}
#dispatch-tooltip .tooltip-content .label {
  color: var(--primary-font-color);
  width: 100%;
  font-size: 11px;
  padding: 0px;
  display: block;
  text-align: left;
  font-weight: 700;
  margin-bottom: 5px;
}
#dispatch-tooltip .tooltip-content .reason {
  max-height: 100px;
  overflow-y: auto;
}
#dispatch-tooltip .tooltip-content .reason .text {
  width: 100%;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/cp-variables.scss","webpack://./src/app/cp/dispatch-board-calendar/dispatch-calendar-obj/dispatch-calendar-obj.component.scss"],"names":[],"mappings":"AAIA;EACI,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gDAAA;EACA,kDAAA;EAIA,wCAAA;EACA,gDAAA;EACA,0CAAA;EACA,6BAAA;EACA,qCAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,0CAAA;EACA,6BAAA;EACA,4CAAA;EAGA,kCAAA;EACA,gDAAA;EACA,4BAAA;EACA,wDAAA;EACA,4CAAA;EACA,sBAAA;EACA,qBAAA;EACA,qCAAA;EACA,wCAAA;EACA,sBAAA;EACA,mCAAA;EAGA,uBAAA;EACA,qBAAA;EAEA,wCAAA;EAGA,uBAAA;EACA,gCAAA;EACA,iDAAA;EACA,uBAAA;EACA,+BAAA;EACA,gDAAA;EACA,kCAAA;EACA,0CAAA;EACA,4CAAA;EACA,sBAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EAGA,oCAAA;EACA,4CAAA;EACA,6CAAA;EACA,oDAAA;EAIA,mCAAA;EACA,mCAAA;EACA,qCAAA;EAGA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EAEA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAIA,yBAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;EAGA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,4BAAA;EACA,iDAAA;EACA,sCAAA;EACA,oCAAA;EACA,uDAAA;AC3BJ;AD6BI;EACI,wBAAA;EAEA,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;AC7BR;;ADsCI;EAAI,SAAA;AClCR;ADmCI;EAAI,uBAAA;AChCR;ADiCI;EAAI,uBAAA;AC9BR;AD+BI;EAAI,uBAAA;AC5BR;AD6BI;EAAI,uBAAA;AC1BR;AD2BI;EAAI,uBAAA;ACxBR;ADyBI;EAAI,uBAAA;ACtBR;ADuBI;EAAI,uBAAA;ACpBR;ADqBI;EAAI,uBAAA;AClBR;ADmBI;EAAI,uBAAA;AChBR;ADkBQ;EAAI,aAAA;ACfZ;ADgBQ;EAAI,2BAAA;ACbZ;ADcQ;EAAI,2BAAA;ACXZ;ADYQ;EAAI,2BAAA;ACTZ;ADUQ;EAAI,2BAAA;ACPZ;ADQQ;EAAI,2BAAA;ACLZ;ADMQ;EAAI,2BAAA;ACHZ;ADIQ;EAAI,2BAAA;ACDZ;ADEQ;EAAI,2BAAA;ACCZ;ADAQ;EAAI,2BAAA;ACGZ;ADAQ;EAAI,eAAA;ACGZ;ADFQ;EAAI,6BAAA;ACKZ;ADJQ;EAAI,6BAAA;ACOZ;ADNQ;EAAI,6BAAA;ACSZ;ADRQ;EAAI,6BAAA;ACWZ;ADVQ;EAAI,6BAAA;ACaZ;ADZQ;EAAI,6BAAA;ACeZ;ADdQ;EAAI,6BAAA;ACiBZ;ADhBQ;EAAI,6BAAA;ACmBZ;ADlBQ;EAAI,6BAAA;ACqBZ;ADlBQ;EAAI,gBAAA;ACqBZ;ADpBQ;EAAI,8BAAA;ACuBZ;ADtBQ;EAAI,8BAAA;ACyBZ;ADxBQ;EAAI,8BAAA;AC2BZ;AD1BQ;EAAI,8BAAA;AC6BZ;AD5BQ;EAAI,8BAAA;AC+BZ;AD9BQ;EAAI,8BAAA;ACiCZ;ADhCQ;EAAI,8BAAA;ACmCZ;ADlCQ;EAAI,8BAAA;ACqCZ;ADpCQ;EAAI,8BAAA;ACuCZ;ADpCI;EAAI,cAAA;ACuCR;ADtCI;EAAI,4BAAA;ACyCR;ADxCI;EAAI,4BAAA;AC2CR;AD1CI;EAAI,4BAAA;AC6CR;AD5CI;EAAI,4BAAA;AC+CR;AD9CI;EAAI,4BAAA;ACiDR;ADhDI;EAAI,4BAAA;ACmDR;ADlDI;EAAI,4BAAA;ACqDR;ADpDI;EAAI,4BAAA;ACuDR;ADtDI;EAAI,4BAAA;ACyDR;;ADrDI;EAAI,UAAA;ACyDR;ADxDI;EAAI,wBAAA;AC2DR;AD1DI;EAAI,wBAAA;AC6DR;AD5DI;EAAI,wBAAA;AC+DR;AD9DI;EAAI,wBAAA;ACiER;ADhEI;EAAI,wBAAA;ACmER;ADlEI;EAAI,wBAAA;ACqER;ADpEI;EAAI,wBAAA;ACuER;ADtEI;EAAI,wBAAA;ACyER;ADxEI;EAAI,wBAAA;AC2ER;ADzEQ;EAAI,cAAA;AC4EZ;AD3EQ;EAAI,4BAAA;AC8EZ;AD7EQ;EAAI,4BAAA;ACgFZ;AD/EQ;EAAI,4BAAA;ACkFZ;ADjFQ;EAAI,4BAAA;ACoFZ;ADnFQ;EAAI,4BAAA;ACsFZ;ADrFQ;EAAI,4BAAA;ACwFZ;ADvFQ;EAAI,4BAAA;AC0FZ;ADzFQ;EAAI,4BAAA;AC4FZ;AD3FQ;EAAI,4BAAA;AC8FZ;AD3FQ;EAAI,gBAAA;AC8FZ;AD7FQ;EAAI,8BAAA;ACgGZ;AD/FQ;EAAI,8BAAA;ACkGZ;ADjGQ;EAAI,8BAAA;ACoGZ;ADnGQ;EAAI,8BAAA;ACsGZ;ADrGQ;EAAI,8BAAA;ACwGZ;ADvGQ;EAAI,8BAAA;AC0GZ;ADzGQ;EAAI,8BAAA;AC4GZ;AD3GQ;EAAI,8BAAA;AC8GZ;AD7GQ;EAAI,8BAAA;ACgHZ;AD7GQ;EAAI,iBAAA;ACgHZ;AD/GQ;EAAI,+BAAA;ACkHZ;ADjHQ;EAAI,+BAAA;ACoHZ;ADnHQ;EAAI,+BAAA;ACsHZ;ADrHQ;EAAI,+BAAA;ACwHZ;ADvHQ;EAAI,+BAAA;AC0HZ;ADzHQ;EAAI,+BAAA;AC4HZ;AD3HQ;EAAI,+BAAA;AC8HZ;AD7HQ;EAAI,+BAAA;ACgIZ;AD/HQ;EAAI,+BAAA;ACkIZ;AD/HQ;EAAI,eAAA;ACkIZ;ADjIQ;EAAI,6BAAA;ACoIZ;ADnIQ;EAAI,6BAAA;ACsIZ;ADrIQ;EAAI,6BAAA;ACwIZ;ADvIQ;EAAI,6BAAA;AC0IZ;ADzIQ;EAAI,6BAAA;AC4IZ;AD3IQ;EAAI,6BAAA;AC8IZ;AD7IQ;EAAI,6BAAA;ACgJZ;AD/IQ;EAAI,6BAAA;ACkJZ;ADjJQ;EAAI,6BAAA;ACoJZ;;ADkBA;;;;;;;;;;;EAAA;AAoCA;;;;;;;;;;;;;;;;QAAA;ACtgBA;EACI,WAAA;EACA,2BAAA;EACA,yBAAA;EACA,aAAA;EAEA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA+eJ;AA9eI;EACI,kCAAA;AAgfR;AA7eC;EACC,4BAAA;EACM,sBAAA;AA+eR;AA9eQ;EACI,cAAA;AAgfZ;AA7eI;EACI,4BAAA;EACA,sBAAA;EACA,yBAAA;AA+eR;AA5eQ;EACI,cAAA;AA8eZ;AAzeE;EACC,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,qCAAA;EACM,sDAAA;AA2eT;AAxeI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA0eR;AAzeQ;EACI,cAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,sCAAA;EACA,uBAAA;AA2eZ;AAzegB;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA2epB;AAzegB;EAAa,YAAA;AA4e7B;AA3egB;EAAa,YAAA;AA8e7B;AA7egB;EAAe,YAAA;AAgf/B;AA/egB;EAAgB,mBAAA;AAkfhC;AAjfgB;EAAqB,mBAAA;AAofrC;AAnfgB;EAAkB,mBAAA;AAsflC;AArfgB;EAAoB,0CAAA;AAwfpC;AAvfgB;EAAc,mBAAA;AA0f9B;AAzfgB;EAA4B,mBAAA;AA4f5C;AA3fgB;EAA8B,mBAAA;AA8f9C;AA3fQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AA6fZ;AAzfQ;EACI,cAAA;AA2fZ;AAzfQ;EACI,mDAAA;AA2fZ;AAxfI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;AA0fR;AAxfI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AA0fR;AAxfQ;EACI,WAAA;AA0fZ;AAxfY;EACI,UAAA;EACA,sCAAA;AA0fhB;AAvfY;EACI,UAAA;EACA,sCAAA;AAyfhB;AAtfY;EACI,UAAA;EACA,qCAAA;AAwfhB;AAxoBA;EAoJI;;;;;;;;;;;;;;;;;;;;;;IAAA;AA6gBJ;AAtfI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,6CAAA;EACA,yBAAA;EACA,UAAA;AAwfR;AAvfQ;EAAM,WAAA;AA0fd;AAxfY;EACI,sCAAA;EACA,WAAA;AA0fhB;AAtfY;EACI,sCAAA;EACA,WAAA;AAwfhB;AApfY;EACI,qCAAA;EACA,YAAA;AAsfhB;AAnfQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAqfZ;AAnfQ;EAAQ,WAAA;AAsfhB;AAjfgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,6CAAA;AAmfpB;AA9eoB;EAAQ,YAAA;AAif5B;AA5eoB;EAAQ,YAAA;AA+e5B;AA1eoB;EAAQ,YAAA;AA6e5B;;AAteA;EACI,eAAA;EACA,gBAAA;AAyeJ;;AAteA;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sDAAA;AAyeJ;;AAveA;EACI,sDAAA;AA0eJ;;AAveA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;EACG,oBAAA;AA0eJ;AAzeI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,qCAAA;AA2eR;AA1eQ;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AA4eZ;AAzeI;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;AA2eR;AA1eQ;EACI,gCAAA;EACA,YAAA;EACA;;sBAAA;AA8eZ;AA3eY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AA6ehB;AA1eQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AA4eZ;AA3eY;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AA6ehB;AAzeC;EACC,gCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA2eF;AA1eQ;EACI,WAAA;EACA,aAAA;EACA,qBAAA;AA4eZ;AA3eY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AA6ehB;AA3egB;EACI,iBAAA;AA6epB;AAzeE;EACC,gCAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA2eH;AAzeE;EACC,iBAAA;EACA,gBAAA;AA2eH;AA1eG;EACC,WAAA;EACA,eAAA;AA4eJ","sourcesContent":["@use \"sass:map\";\n@use \"sass:color\";\n@use \"sass:math\";\n\n:root{\n    --primary-color: #0255A5;\n    --primary-color-rgb:2, 85, 165; // For RGBA methods - Make sure to match value with hex code\n    --primary-color-hover:#0F3B66;\n    --primary-color-opacity: rgba(2, 85, 165, 0.1);\n    --light-grey:#F9F9F9;\n    --light-grey-rgb:249, 249, 249; // For RGBA methods - Make sure to match value with hex code\n    --dark-grey:#9A9C9F;\n    --dark-grey-rgb:154, 156, 159; // For RGBA methods - Make sure to match value with hex code\n    --darkGrey:#1b232c;\n    --hover-bg-color:#E4E8EF;\n    --white-bg-hover:#e8eff2;\n    --light-blue:#6A80A9;\n    --purple:#675081;\n    --purple-rgb:103, 80, 129;// For RGBA methods - Make sure to match value with hex code\n    --textHighlightBgColor:rgba(191, 219, 253, 0.90);\n    --textHighlightFontColor:var(--primary-font-color);\n\n\n    //Fonts\n    --primary-font-color: var(--surface-500);\n    --primary-font-color-rgb: var(--surface-500-rgb);\n    --secondary-font-color: var(--surface-700);\n    --disabled-font-color:#828b97;\n    --font:\"Open Sans\", Arial, sans-serif;\n    --h1:24px;\n    --h2:18px;\n    --h3:16px;\n    --h4:13px;\n    --bodyFontSize:14px;\n    --tableFontSize:12px;\n    --pageTitleSize:var(--h1);\n    --sectionTitleSize:var(--h2);\n    --sectionSubTitleSize:var(--tableFontSize);\n    --sectionTitleLabel:var(--h3);\n    --accordionTitleSize:var(--sectionTitleSize);\n\n    //Borders\n    --border-color: var(--surface-100);\n    --darkBorderColor: var(--textHighlightFontColor);\n    --table-border-color:#E8EFF2;\n    --table-border-style:1px solid var(--table-border-color);\n    --border-style:1px solid var(--border-color);\n    --border-lg-radius:8px;\n    --border-m-radius:4px;\n    --border-m-radius-top:4px 4px 0px 0px;\n    --border-m-radius-bottom:0px 0px 4px 4px;\n    --border-sm-radius:2px;\n    --border-radius-tab:2px 2px 0px 0px;\n\n    //Text highlight colors\n    --selected-text:#E4E8EF;\n    --selected-bg:#E4E8EF;\n\n    --table-alt-row-color: var(--light-grey);\n\n    // Alert & Notification Colors\n    --alert-warning:#D6BA17;\n    --alert-warning-rgb:214, 186, 23; // For RGBA methods - Make sure to match value with hex code\n    --alert-warning-opacity: rgba(214, 186, 23, 0.10);\n    --alert-success:#02a570;\n    --alert-success-rgb:2, 165, 112;\n    --alert-success-opacity: rgba(2, 165, 112, 0.10);\n    --alert-info: var(--primary-color);\n    --alert-info-rgb: var(--primary-color-rgb); // For RGBA methods - Make sure to match value with hex code\n    --alert-info-opacity: rgba(2, 85, 165, 0.11);\n    --alert-danger:#E02222;\n    --alert-danger-rgb:224, 34, 34;\n    --alert-danger-opacity: rgba(224, 34, 34, 0.10);\n    --alert-danger-hover: #871a1a;\n    --alert-medium:#F97031;\n    --alert-medium-rgb:249, 112, 49; // For RGBA methods - Make sure to match value with hex code\n    --brown:#5b4434;\n    --notification-warning-bg:#FAF8E7;\n    --notification-info-bg:#E5EEF6;\n    --notification-error-bg:#FBE8E8;\n    --notification-success-bg:#E5F6F0;\n\n    //Shadows\n    --shadow-color:rgba(89,101,118,0.32);\n    --shadow-sm: 0 2px 5px 0 var(--shadow-color);\n    --shadow-md: 0 0px 10px 0 var(--shadow-color);\n    --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n\n    // Misc\n    --accent: $primary-color !important;\n    --primary: $primary-color!important;\n    --series-a: $primary-color !important;\n\n    // System Colors\n    --primary-0:#ebf7ff;\n    --primary-0-rgb:235, 247, 255; // For RGBA methods - Make sure to match value with hex code\n    --primary-50:#a9d3ef;\n    --primary-100:#6fb2de;\n    --primary-100-rgb:111, 178, 222; // For RGBA methods - Make sure to match value with hex code\n    --primary-200:#4093cd;\n    --primary-300:#1c74ba;\n    --primary-300-rgb:28, 116, 186; // For RGBA methods - Make sure to match value with hex code\n    --primary-400:#0255A5;\n    --primary-500:#0046aa;\n    --primary-600:#0b399c;\n    --primary-700:#102669;\n    --primary-800:#08112d;\n    --primary-900:#070a16;\n\n    --white:#ffffff;\n    --white-rgb:255, 255, 255; // For RGBA methods - Make sure to match value with hex code\n    --surface-0: #fefefe;\n    --surface-50: #d7dfe5;\n    --surface-50-rgb:215, 223, 229; // For RGBA methods - Make sure to match value with hex code\n    --surface-100: #bac4cb;\n    --surface-100-rgb:186, 196, 203; // For RGBA methods - Make sure to match value with hex code\n    --surface-200: #9ea8b1;\n    --surface-200-rgb:158, 168, 177; // For RGBA methods - Make sure to match value with hex code\n    --surface-300: #828b97;\n    --surface-400: #666f7d;\n    --surface-500: #4B5363;\n    --surface-500-rgb:75, 83, 99; // For RGBA methods - Make sure to match value with hex code\n    --surface-600: #373d4f;\n    --surface-700: #25283a;\n    --surface-700-rgb:37, 40, 58; // For RGBA methods - Make sure to match value with hex code\n    --surface-800: #151726;\n    --surface-800-rgb:21, 23, 38; // For RGBA methods - Make sure to match value with hex code\n    --surface-900: #090912;\n\n    --size-0: 2px;\n    --size-50: 4px;\n    --size-100: 6px;\n    --size-200: 8px;\n    --size-300: 10px;\n    --size-400: 16px;\n    --size-500: 32px;\n    --size-600: 48px;\n    --size-700: 54px;\n    --size-800: 70px;\n    --size-900: 86px;\n\n\n    //Media Queries\n    --media-tablet-pro: 992px;\n    --media-tablet: var(--media-tablet-pro);\n    --media-mobile: 480px;\n    --media-min: 0px;\n\n    // Priority Colors\n    --priority-pm:var(--primary-color);\n    --priority-high:var(--alert-danger);\n    --priority-hot-parts: #059ea5;\n    --priority-warranty: #e035bf;\n    --priority-overtime-approval:var(--alert-warning);\n    --priority-normal:var(--alert-success);\n    --priority-special-equipment:#675081;\n    --priority-locked-scheduled:var(--secondary-font-color);\n\n    .zuggit-base{\n        --primary-color: #323283;\n\n        --primary-0: #f2f4ff;\n        --primary-0-rgb:242, 244, 255; // For RGBA methods - Make sure to match value with hex code\n        --primary-50: #c4c5f2;\n        --primary-100: #9b9be6;\n        --primary-100-rgb:155, 155, 230; // For RGBA methods - Make sure to match value with hex code\n        --primary-200: #7b7cd9;\n        --primary-300: #5a5acb;\n        --primary-300-rgb:90, 90, 203; // For RGBA methods - Make sure to match value with hex code\n        --primary-400: #323283;\n        --primary-500: #2a2a95;\n        --primary-600: #242484;\n        --primary-700: #1d1d63;\n        --primary-800: #141441;\n        --primary-900: #0c0c22;\n\n        --surface-0: #fbfaff;\n        --surface-50: #dcd9e4;\n        --surface-50-rgb:220, 217, 228; // For RGBA methods - Make sure to match value with hex code\n        --surface-100: #c1beca;\n        --surface-100-rgb:193, 190, 202; // For RGBA methods - Make sure to match value with hex code\n        --surface-200: #a6a3b1;\n        --surface-200-rgb:166, 163, 177; // For RGBA methods - Make sure to match value with hex code\n        --surface-300: #8b8798;\n        --surface-400: #716c80;\n        --surface-500: #585166;\n        --surface-500-rgb:88, 81, 102; // For RGBA methods - Make sure to match value with hex code\n        --surface-600: #423b4f;\n        --surface-700: #2e2938;\n        --surface-700-rgb:46, 41, 56; // For RGBA methods - Make sure to match value with hex code\n        --surface-800: #1c1824;\n        --surface-800-rgb:28, 24, 36; // For RGBA methods - Make sure to match value with hex code\n        --surface-900: #0d0a12;\n\n\n\n    }\n\n}\n\n.m{\n    &-0{margin: 0;}\n    &-1{margin: var(--size-100);}\n    &-2{margin: var(--size-200);}\n    &-3{margin: var(--size-300);}\n    &-4{margin: var(--size-400);}\n    &-5{margin: var(--size-500);}\n    &-6{margin: var(--size-600);}\n    &-7{margin: var(--size-700);}\n    &-8{margin: var(--size-800);}\n    &-9{margin: var(--size-900);}\n    &t{\n        &-0{margin-top: 0;}\n        &-1{margin-top: var(--size-100);}\n        &-2{margin-top: var(--size-200);}\n        &-3{margin-top: var(--size-300);}\n        &-4{margin-top: var(--size-400);}\n        &-5{margin-top: var(--size-500);}\n        &-6{margin-top: var(--size-600);}\n        &-7{margin-top: var(--size-700);}\n        &-8{margin-top: var(--size-800);}\n        &-9{margin-top: var(--size-900);}\n    }\n    &r{\n        &-0{margin-right: 0;}\n        &-1{margin-right: var(--size-100);}\n        &-2{margin-right: var(--size-200);}\n        &-3{margin-right: var(--size-300);}\n        &-4{margin-right: var(--size-400);}\n        &-5{margin-right: var(--size-500);}\n        &-6{margin-right: var(--size-600);}\n        &-7{margin-right: var(--size-700);}\n        &-8{margin-right: var(--size-800);}\n        &-9{margin-right: var(--size-900);}\n    }\n    &b{\n        &-0{margin-bottom: 0;}\n        &-1{margin-bottom: var(--size-100);}\n        &-2{margin-bottom: var(--size-200);}\n        &-3{margin-bottom: var(--size-300);}\n        &-4{margin-bottom: var(--size-400);}\n        &-5{margin-bottom: var(--size-500);}\n        &-6{margin-bottom: var(--size-600);}\n        &-7{margin-bottom: var(--size-700);}\n        &-8{margin-bottom: var(--size-800);}\n        &-9{margin-bottom: var(--size-900);}\n    }\n    &l{\n    &-0{margin-left: 0;}\n    &-1{margin-left: var(--size-100);}\n    &-2{margin-left: var(--size-200);}\n    &-3{margin-left: var(--size-300);}\n    &-4{margin-left: var(--size-400);}\n    &-5{margin-left: var(--size-500);}\n    &-6{margin-left: var(--size-600);}\n    &-7{margin-left: var(--size-700);}\n    &-8{margin-left: var(--size-800);}\n    &-9{margin-left: var(--size-900);}\n    }\n}\n.p{\n    &-0{padding: 0;}\n    &-1{padding: var(--size-100);}\n    &-2{padding: var(--size-200);}\n    &-3{padding: var(--size-300);}\n    &-4{padding: var(--size-400);}\n    &-5{padding: var(--size-500);}\n    &-6{padding: var(--size-600);}\n    &-7{padding: var(--size-700);}\n    &-8{padding: var(--size-800);}\n    &-9{padding: var(--size-900);}\n    &t{\n        &-0{padding-top: 0;}\n        &-1{padding-top: var(--size-100);}\n        &-2{padding-top: var(--size-200);}\n        &-3{padding-top: var(--size-300);}\n        &-4{padding-top: var(--size-400);}\n        &-5{padding-top: var(--size-500);}\n        &-6{padding-top: var(--size-600);}\n        &-7{padding-top: var(--size-700);}\n        &-8{padding-top: var(--size-800);}\n        &-9{padding-top: var(--size-900);}\n    }\n    &r{\n        &-0{padding-right: 0;}\n        &-1{padding-right: var(--size-100);}\n        &-2{padding-right: var(--size-200);}\n        &-3{padding-right: var(--size-300);}\n        &-4{padding-right: var(--size-400);}\n        &-5{padding-right: var(--size-500);}\n        &-6{padding-right: var(--size-600);}\n        &-7{padding-right: var(--size-700);}\n        &-8{padding-right: var(--size-800);}\n        &-9{padding-right: var(--size-900);}\n    }\n    &b{\n        &-0{padding-bottom: 0;}\n        &-1{padding-bottom: var(--size-100);}\n        &-2{padding-bottom: var(--size-200);}\n        &-3{padding-bottom: var(--size-300);}\n        &-4{padding-bottom: var(--size-400);}\n        &-5{padding-bottom: var(--size-500);}\n        &-6{padding-bottom: var(--size-600);}\n        &-7{padding-bottom: var(--size-700);}\n        &-8{padding-bottom: var(--size-800);}\n        &-9{padding-bottom: var(--size-900);}\n    }\n    &l{\n        &-0{padding-left: 0;}\n        &-1{padding-left: var(--size-100);}\n        &-2{padding-left: var(--size-200);}\n        &-3{padding-left: var(--size-300);}\n        &-4{padding-left: var(--size-400);}\n        &-5{padding-left: var(--size-500);}\n        &-6{padding-left: var(--size-600);}\n        &-7{padding-left: var(--size-700);}\n        &-8{padding-left: var(--size-800);}\n        &-9{padding-left: var(--size-900);}\n    }\n}\n\n$primaryColor:#0255A5;\n$primaryFontColor:#4B5363;\n$white: #ffffff;\n\n//DarkMode\n$primaryDM: #2A2E3A;\n$primaryFontColorDM: #eeeeee;\n\n$colors: (\n        blue: (\n                base: $primaryColor,\n                0: #ebf7ff,\n                10: #a9d3ef,\n                20: #6fb2de,\n                30: #4093cd,\n                40: #1c74ba,\n                50: $primaryColor,\n                60: #0046aa,\n                70: #0b399c,\n                80: #102669,\n                90: #08112d,\n                100: #070a16,\n        ),\n        neutral: (\n                base: $primaryFontColor,\n                0: #fefefe,\n                10: #d7dfe5,\n                20: #bac4cb,\n                30: #9ea8b1,\n                40: #828b97,\n                50: #666f7d,\n                60: $primaryFontColor,\n                70: #373d4f,\n                80: #25283a,\n                90: #151726,\n                100: #090912,\n        ),\n        primary: (\n                base: $primaryColor,\n                light: color.scale($primaryColor, $lightness: 15%),\n                dark: color.scale($primaryColor, $blackness: 30%),\n                disabled: color.scale($primaryColor, $saturation: -90%, $lightness: 60%),\n                darkMode:$primaryDM,\n        ),\n        white: (\n                base:var(--white),\n                hover: color.scale($primaryColor, $lightness: 80%, $saturation: -82%),\n                dark: color.scale($white, $blackness: 30%),\n\n        ),\n        font:(\n                base: $primaryFontColor,\n                secondary: color.scale($primaryFontColor, $blackness: 30%),\n                disabled: color.scale($primaryFontColor, $saturation: -10%, $lightness: 20%),\n                darkMode:$primaryFontColorDM,\n        )\n);\n\n$shadow: 0 0px 10px 0 #151726;\n\n\n$fonts: (\n        \"Helvetica\": (\n                \"weights\": (\n                        \"regular\": 400,\n                        \"medium\": 500,\n                        \"bold\": 700\n                )\n        )\n);\n\n@function get-color($color, $shade: base) {\n    @return map.get(map.get($colors, $color), $shade);\n}\n\n\n\n\n///////////////////////////////////////////\n// DEPRECATED DO NOT USE THESE VARIABLES //\n///////////////////////////////////////////\n\n\n// Climate Pros Font Colors\n$primary-font-color:#1b232c; //\n$secondary-font-color:#4B5363;//\n$disabled-font-color:#8A939D;//\n$light-grey:#F9F9F9;//\n$dark-grey:#9A9C9F;//\n//var(--white):#ffffff;\n\n// Climate Pros Colors\n$primary-color:#0255A5;\n$primary-color-hover:#0F3B66;\n$primary-color-opacity:rgba(2, 85, 165, 0.1);\n$darkgrey:var(--secondary-font-color);\n$hover-bg-color:#E4E8EF;\n$white-bg-hover:#e8eff2;\n$light-blue:#6A80A9;\n$purple:#675081;\n$textHighlightBgColor:rgba(#BFDBFD, 0.90);\n$textHighlightFontColor:var(--secondary-font-color);\n\n\n// CP Borders\n//var(--border-color): #D5DDE2;\n$border-color: #bac4cb;\n$darkBorderColor: var(--textHighlightFontColor);\n$table-border-color:#E8EFF2;\n$table-border-style:1px solid var(--table-border-color);\n$border-style:1px solid var(--border-color);\n//var(--border-style):1px solid var(--border-color);var(--surface-0)\n$border-lg-radius:8px;\n$border-m-radius:4px;\n$border-m-radius-top:4px 4px 0px 0px;\n$border-m-radius-bottom:0px 0px 4px 4px;\n$border-sm-radius:2px;\n$border-radius-tab:2px 2px 0px 0px;\n\n$selected-text:#E4E8EF;\n$selected-bg:#E4E8EF;\n\n$table-alt:var(--light-grey);\n\n// Alert Colors\n$alert-warning:#D6BA17;\n$alert-warning-opacity: rgba(214, 186, 23, 0.10);\n$alert-success:#02a570;\n$alert-success-opacity: rgba(2, 165, 112, 0.10);\n$alert-info:var(--primary-color);\n$alert-info-opacity: rgba(2, 85, 165, 0.11);\n$alert-danger:#E02222;\n$alert-danger-opacity: rgba(224, 34, 34, 0.10);\n$alert-danger-hover: #871a1a;\n$alert-medium:#F97031;\n$brown:#5b4434;\n\n$notification-warning-bg:#FAF8E7;\n$notification-info-bg:#E5EEF6;\n$notification-error-bg:#FBE8E8;\n$notification-success-bg:#E5F6F0;\n\n\n//Shadows\n$shadow-color:rgba(89,101,118,0.32);\n$shadow-sm: 0 2px 5px 0 var(--shadow-color);\n$shadow-md: 0 0px 10px 0 var(--shadow-color);\n$shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n//Fonts\n$font:\"Open Sans\", Arial, sans-serif;\n$h1:24px;\n$h2:18px;\n$h3:16px;\n$h4:13px;\n$bodyFontSize:14px;\n$tableFontSize:12px;\n$pageTitleSize:var(--h1);\n$sectionTitleSize:var(--h2);\n$sectionSubTitleSize:var(--tableFontSize);\n$sectionTitleLabel:var(--h3);\n$accordionTitleSize:var(--sectionTitleSize);\n/*%pageTitleFont{\n    font-size:$pageTitleSize;\n    font-weight:800;\n}\n%sectionTitleFont{\n    font-size:var(--sectionTitleSize);\n    font-weight:800;\n}\n%sectionSubTitleFont{\n    font-size:var(--sectionSubTitleSize);\n    font-weight:400;\n}*/\n\n\n//Prioritys\n$priority-pm:var(--primary-color);\n$priority-high:var(--alert-danger);\n$priority-hot-parts: #059ea5;\n$priority-warranty: #e035bf;\n$priority-overtime-approval:var(--alert-warning);\n$priority-normal:var(--alert-success);\n$priority-special-equipment:#675081;\n$priority-locked-scheduled:var(--secondary-font-color);\n\n//Spacing\n$fullSpacing:30px;\n$halfSpacing:calc($fullSpacing/2);\n$quarterSpacing:calc($fullSpacing/4);\n\n\n//Media Queries\n$mediaTabletPro: 992px;\n$mediaTablet: $mediaTabletPro;\n$mediaMobile: 480px;\n$mediaMin: 0px;\n\n/* chart \nbuttons\ndate input\ndialogs\ndropdowns\niputs\ngrid\nlabel\nlayout\ntab strip\nbound bar\nmenues\npopup\nscroll view\ntoolbar\ntool tip\neditor */\n\n\n////////////////////\n//Dark Mode Colors//\n////////////////////\n$darkModeAppBg:#22252A;\n$darkModeBg1:#2A2E3A;\n$darkModeBg2:#2A2E36;\n$darkModeBg3:#15161a;\n$darkModeBorderColor:#484D5A;\n$darkModeOutlineBtnBg:#262A31;\n$darkModeInputBg:$darkModeBg1;\n$darkModePrimaryFontColor:#eeeeee;\n$darkModeSecondaryFontColor:var(--white);\n$darkModeDisabledFontColor:rgba($darkModePrimaryFontColor, .4);\n$darkModeDrawerBg:#15191d;\n\n\n\n\n// FUNCTIONS\n$browser-context: 16; // Default\n\n@function em($pixels, $context: $browser-context) {\n    @return #{$pixels/$context}em;\n}\n","@use \"./src/assets/scss/cp-variables.scss\" as *;\n\n.dispatch {\n    width: 100%;\n    border: var(--border-style);\n    background-color: #ffffff;\n    display: flex;\n    //flex-wrap: nowrap;\n    flex-wrap: wrap;\n    flex-direction: row;\n    padding: 0px 5px;\n    border-radius: var(--border-m-radius);\n    cursor: pointer;\n    position: relative;\n    margin: 5px 0;\n    align-items: center;\n    &.hasLabor h3{\n        color:var(--secondary-font-color);\n        //font-weight: 600;\n    }\n\t&.dispatch-focused{\n\t\tbox-shadow: var(--shadow-sm);\n        transform: scale(1.08);\n        .dispatch-menu {\n            display: block\n        }\n\t}\n    &:hover {\n        box-shadow: var(--shadow-sm);\n        transform: scale(1.02);\n        transition-duration: 0.2s;\n        //z-index: 99999999;\n\n        .dispatch-menu {\n            display: block\n        }\n    }\n\n    &.selected-dispatch {\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\ttop: 0px;\n\t\t\tleft: 0px;\n\t\t\tz-index: 20;\n\t\t\tpointer-events: none;\n\t\t\tborder-radius:var(--border-m-radius);\n        \tbox-shadow: inset 0px 0px 6px 0px var(--primary-color);\n\t\t}\n    }\n    .dispatchDetails{\n        width:100%;\n        display:flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-items: center;\n        .priority-block{\n            display:block;\n            width:12px;\n            min-width:8px;\n            height:12px;\n            border-radius:var(--border-sm-radius);\n            margin:0px 5px 0px 0px;\n            &.partPriorityNumber{\n                &::after{\n                    content:'';\n                    position:absolute;\n                    text-align:center;\n                    width:12px;\n                    height:12px;\n                    font-size: 10px;\n                    font-weight: 900;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                }\n                &.one::after{content:'1';}\n                &.two::after{content:'2';}\n                &.three::after{content:'3';}\n                &.priority-high{color:var(--white);}\n                &.priority-hot-parts{color:var(--white);}\n                &.priority-normal{color:var(--white);}\n                &.priority-warranty{background-color:var(--priority-warranty);}\n                &.priority-pm{color:var(--white);}\n                &.priority-locked-scheduled{color:var(--white);}\n                &.priority-special-equipment {color:var(--white);}\n            }\n        }\n        h3{\n            display:block;\n            font-size:12px;\n            font-weight:400;\n            color:var(--primary-font-color);\n            flex-grow:2;\n            text-overflow:ellipsis;\n            white-space:nowrap;\n            min-width:calc(100% - 13px);\n            padding:0px;\n            margin:0px;\n            line-height:34px;\n            overflow:hidden\n        }\n    }\n    &.white{\n        .dispatchDetails h3{\n            color:#ffffff;\n        }\n        .partPriority{\n            border-top-color:rgba( var(--surface-100-rgb), 0.5);\n        }\n    }\n    .dispatch-menu{\n        position:absolute;\n        right:1px;\n        top:1px;\n        display:none;\n        z-index:9999;\n        background-color:#ffffff;\n        pointer-events: none;\n    }\n    .dispatch-timer-wrap{\n        position: absolute;\n        width: 100%;\n        height: 4px;\n        border-top: var(--border-style);\n        overflow: hidden;\n        bottom: 0px;\n        margin: 0px -5px;\n\n        .dispatch-timer {\n            height: 3px;\n\n            &.two-hour {\n                width: 33%;\n                background-color: var(--alert-success);\n            }\n\n            &.four-hour {\n                width: 33%;\n                background-color: var(--alert-warning);\n            }\n\n            &.twenty-four-hour {\n                width: 33%;\n                background-color: var(--alert-danger);\n            }\n        }\n    }\n    /*.partPriority{\n        display:flex;\n        flex-direction: row;\n        height: 4px;\n        width: calc(100% + 10px);\n        margin: 0 -5px 0 -5px;\n        border-width: 1px 0 0 0;\n        border-top-color: var(--border-color);\n        border-style: solid;\n        .step{\n            flex-grow:1;\n            border-width: 0 1px 0 0;\n            border-color: var(--border-color);\n            border-style:solid;\n            background-color: rgba( var(--white-rgb), 0.6);\n            &:last-child{\n              border:none;\n            }\n            &.levelOne{background-color:var(--primary-color);}\n            &.levelTwo{background-color:var(--alert-warning);}\n            &.levelThree{background-color:var(--alert-danger);}\n        }\n    }*/\n    .partPriority{\n        position:relative;\n        display:flex;\n        flex-direction:column;\n        height:34px;\n        width:5px;\n        border-radius:0 4px 4px 0;\n        margin-right:-5px;\n        border-width:0 0 0 1px;\n        border-color:var(--border-color);\n        border-style:solid;\n        background-color:rgba( var(--white-rgb), 0.6);\n        justify-content:flex-end;\n        z-index: 0;\n        .step{width:100%;}\n        &.levelOne{\n            .step{\n                background-color:var(--primary-color);\n                height:33%;\n            }\n        }\n        &.levelTwo{\n            .step{\n                background-color:var(--alert-warning);\n                height:66%;\n            }\n        }\n        &.levelThree{\n            .step{\n                background-color:var(--alert-danger);\n                height:100%;\n            }\n        }\n        &:before{\n            content:'';\n            height:33%;\n            width:100%;\n            border-width:1px 0;\n            border-color:var(--border-color);\n            border-style:solid;\n            position:absolute;\n            left:0;\n            right:0;\n            top:0;\n            bottom:0;\n            margin:auto;\n            z-index:1;\n        }\n        &:after{content:'';}\n    }\n    &:hover{\n        .partPriority{\n            .step{\n                &:after{\n                    position:absolute;\n                    top:-1px;\n                    left:-20px;\n                    width:20px;\n                    height:calc(100% + 2px);\n                    display:flex;\n                    justify-content:center;\n                    align-items:center;\n                    font-size:10px;\n                    font-weight:900;\n                    border-radius:4px 0 0 4px;\n                    border-width:1px;\n                    border-color:var(--border-color);\n                    border-style:solid;\n                    background-color:rgba( var(--white-rgb), 0.6);\n                }\n            }\n            &.levelOne{\n                .step{\n                    &:after{content:'1';}\n                }\n            }\n            &.levelTwo{\n                .step{\n                    &:after{content:'2';}\n                }\n            }\n            &.levelThree{\n                .step{\n                    &:after{content:'3';}\n                }\n            }\n        }\n    }\n}\n\n.cdk-drag-dragging {\n    position: fixed; \n    max-width: 200px;\n}\n\n.drag-placeholder {\n    height: 40px;\n    margin: 5px;\n    width: 100%;\n    border-color: var(--disabled-font-color);\n    background-color: var(--shadow-color);\n    opacity: 0.4;\n    border-radius: 4px;\n    border-style: dashed;\n    border-width: 3px;\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n.cdk-drag-animating {\n    transition: transform 300ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n#dispatch-tooltip{\n\tdisplay: flex;\n\tflex-flow:row wrap;\n\tmax-width:315px;\n    z-index: 99999999999;\n    .tooltip-logo{\n        min-width:60px;\n        max-width:60px;\n        min-height:60px;\n        max-height:60px;\n        overflow:hidden;\n        text-align:center;\n        margin-right:10px;\n        border:var(--border-style);\n        border-radius:var(--border-m-radius);\n        img{\n            object-fit:contain;\n            width:100%;\n            height: 100%;\n        }\n    }\n    .tooltip-header {\n        display: flex;\n        flex-flow: row nowrap;\n        margin-bottom:10px;\n        .tooltip-title {\n            color: var(--primary-font-color);\n            flex-grow: 2;\n            /*display: flex;\n            flex-flow: row wrap;\n            margin-bottom:20px;*/\n            h1 {\n                font-size: 16px;\n                font-weight: 700;\n                margin: 0 0 5px 0;\n                width: 100%;\n            }\n        }\n        .location{\n            display: flex;\n            flex-flow:row wrap;\n            width:100%;\n            span{\n                font-size:12px;\n                width:100%;\n                font-weight: 500;\n            }\n        }\n    }\n\t.tooltip-content{\n\t\tcolor:var(--primary-font-color);\n\t\twidth:100%;\n\t\tdisplay: flex;\n\t\tflex-flow: column wrap;\n        .sub-header {\n            width: 100%;\n            display: flex;\n            flex-flow: row nowrap;\n            h2 {\n                font-size: 12px;\n                font-weight: 500;\n                margin: 0 0 10px 0;\n                flex-grow: 2;\n\n                &:last-child {\n                    text-align: right;\n                }\n            }\n        }\n\t\t.label{\n\t\t\tcolor:var(--primary-font-color);\n\t\t\twidth:100%;\n\t\t\tfont-size:11px;\n\t\t\tpadding:0px;\n\t\t\tdisplay: block;\n\t\t\ttext-align: left;\n\t\t\tfont-weight:700;\n\t\t\tmargin-bottom:5px;\n\t\t}\n\t\t.reason{\n\t\t\tmax-height:100px;\n\t\t\toverflow-y:auto;\n\t\t\t.text{\n\t\t\t\twidth:100%;\n\t\t\t\tfont-size:13px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
